import { toast } from "react-toastify";
import { api } from "../Configurations/axios";

//Get

const GetAllAnalysis = async (companyId: string) => {
    try {
        const result = await api.get(`/Analysis/GetAllByCompany/?companyId=${companyId}`);
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const GetAllAnalysisByVersion = async (companyId: string, version: number) => {
    try {
        const result = await api.get(`/Analysis/GetAllByCompanyAndVersion/`, {
            params: {
                companyId,
                version
            }
        });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const GetAllFiles = async (typeOfFile: number, companyId: string, yearName: string) => {
    try {
        const result = await api.get(`/DreAndBalance/GetFilesDREorBalance/?typeFile=${typeOfFile}&companyId=${companyId}&yearName=${yearName}`);
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}
const GetShowWarningFilesAPI = async (companyId: string, year: number[]) => {
    try {
        const result = await api.get(`/DreAndBalance/GetShowWarningFiles/?companyId=${companyId}&years=${year.join(",")}`);
        const response = await result.data;
        return response;
    }
    catch (error: any) {
        throw new Error(error.response.data);
    }
}
const GetAllDREAndBalanceYears = async (companyId: string) => {
    try {
        const result = await api.get(`/DreAndBalance/GetAllYearsByCompany/?companyId=${companyId}`);
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const GetAllVersionsByCompanyAPI = async (companyId: string) => {
    try {
        const result = await api.get(`/Analysis/GetAllVersionsByCompany/?companyId=${companyId}`);
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const GetAnalysisPercentages = async (ebtidaId: string, indebtednessId: string, availabilityId: string, analysisId: string) => {
    try {
        const result = await api.get('/Analysis/GetPercentagesToView', {
            params: {
                ebtidaId: ebtidaId,
                indebtednessId: indebtednessId,
                availabilityId: availabilityId,
                analysisId: analysisId
            }
        });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

//Post

const CreateDREAndBalanceYear = async (companyId: string, year: string, userEmail: string) => {
    try {
        const result = await api.post("/DreAndBalance/CreateYear", { Year: year, CompanyId: companyId, userEmail: userEmail });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const CreateAnalysisYear = async (year: string, companyId: string, userEmail: string, version: number) => {
    try {
        const result = await api.post('/Analysis/Post', { year, companyId, userEmail, version });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const CreateAnalysisVersion = async (companyId: string, userEmail: string, version: number) => {
    try {
        const result = await api.post('/Analysis/PostVersion', { companyId, userEmail, version });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const CreateAnalysisCopyAPI = async (companyId: string, userEmail: string, version: number) => {
    try {
        const result = await api.post('/Analysis/CreateAnalysisCopy', { companyId, userEmail, version });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const UploadFileAnalysis = async (file: any, url: string, year: string, userEmail: string, companyId: string, typeOfFile: number, pathMain: string) => {
    try {
        var UploadFileDreAndBalanceCommand = new FormData();

        UploadFileDreAndBalanceCommand.append("ImageFile", file);

        const result = await api.post(`/DreAndBalance/PostFilesDREAndBalance?Url=${url}&PathName=${year}&userEmail=${encodeURIComponent(userEmail)}&CompanyId=${companyId}&DreOrBalance=${typeOfFile}&pathMain=${pathMain}`, UploadFileDreAndBalanceCommand, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

//Put

const PutGuaranteeOnCompany = async (id: string, guarantee: string[], other: string | undefined, userEmail: string) => {
    try {
        const result = await api.put("/Analysis/PutGuaranteeOnCompany", { id: id, guaranteeType: guarantee, other: other, userEmail: userEmail });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const PutStatesOnCompany = async (id: string, states: string[], userEmail: string) => {
    try {
        const result = await api.put("/Analysis/PutStatesOnCompany", { id: id, states: states, userEmail: userEmail });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const PutRenegotiationObservation = async (id: string, observation: string, userEmail: string) => {
    try {
        const result = await api.put("/Analysis/PutRenegotiationObservation", { id: id, observation: observation, userEmail: userEmail });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const PutOperationRefusedObservation = async (id: string, observation: string, userEmail: string) => {
    try {
        const result = await api.put("/Analysis/PutOperationRefusedObservation", { id: id, observation: observation, userEmail: userEmail });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const PutApproximateValueCompany = async (id: string, value: number, userEmail: string) => {
    try {
        const result = await api.put("/Analysis/PutApproximateValueOnCompany", { id: id, value: value, userEmail: userEmail });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const PutPotentialValue = async (analysisId: string, potentialValue: string, userEmail: string, companyId: string) => {
    try {
        const result = await api.put(`/Analysis/PutPotentialValue`, { Id: analysisId, PotentialValue: potentialValue, userEmail: userEmail, companyId: companyId });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const PutAnalysisObservation = async (analysisId: string, observation: string, userEmail: string, companyId: string) => {
    try {
        const result = await api.put('/Analysis/PutObservation', { id: analysisId, observation: observation, userEmail: userEmail, companyId: companyId });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const PutAnalysisJustification = async (analysisId: string, justification: string, userEmail: string, companyId: string) => {
    try {
        const result = await api.put('/Analysis/PutJustification', { id: analysisId, justification: justification, userEmail: userEmail, companyId: companyId });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const PutAnalysisConcludedAPI = async (companyId: string, checkedValue: boolean, userEmail: string) => {
    try {
        const result = await api.put('/Analysis/PutAnalysisConcluded', { companyId: companyId, checkedValue: checkedValue, userEmail: userEmail });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

//Delete

const DeleteFileDreOrBalance = async (pathName: string, fileName: string, fileId: string, companyId: string) => {
    try {
        const data = { pathName: pathName, fileName: fileName, fileId: fileId, companyId: companyId };

        const result = await api.delete("/DreAndBalance/DeleteFileInDREOrBalance", { data });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const DeleteDREAndBalanceYear = async (companyId: string, yearId: string, pathName: string) => {
    try {
        const data = { companyId: companyId, yearId: yearId, pathName: pathName };
        const result = await api.delete('/DreAndBalance/DeleteYear/', { data });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const DeleteAnalysisYear = async (year: string, companyId: string, version: number) => {
    try {
        const result = await api.delete('/Analysis/DeleteYear', { data: { year, companyId, version } });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const DeleteWIPAnalysisAPI = async (companyId: string, version: number) => {
    try {
        const result = await api.delete('/Analysis/DeleteWIPAnalysis', { data: { companyId, version } });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const DeleteAnalysisVersionAPI = async (companyId: string, version: number) => {
    try {
        const result = await api.delete('/Analysis/DeleteAnalysisVersion', { data: { companyId, version } });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

export {
    GetAllAnalysis,
    GetAllFiles,
    GetShowWarningFilesAPI,
    GetAllDREAndBalanceYears,
    GetAllVersionsByCompanyAPI,
    GetAnalysisPercentages,
    CreateDREAndBalanceYear,
    CreateAnalysisCopyAPI,
    CreateAnalysisYear,
    UploadFileAnalysis,
    PutGuaranteeOnCompany,
    PutStatesOnCompany,
    PutRenegotiationObservation,
    PutOperationRefusedObservation,
    PutApproximateValueCompany,
    PutPotentialValue,
    PutAnalysisObservation,
    PutAnalysisJustification,
    PutAnalysisConcludedAPI,
    DeleteFileDreOrBalance,
    DeleteDREAndBalanceYear,
    DeleteWIPAnalysisAPI,
    DeleteAnalysisYear,
    CreateAnalysisVersion,
    GetAllAnalysisByVersion,
    DeleteAnalysisVersionAPI
}